import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'subscribefail-modal',
    templateUrl: './subscribefail-modal.component.html',
    standalone: false
})

export class SubscribFailModalComponent {
    public title : string;
    public content : string;

    constructor(
        private route: ActivatedRoute
    ) {}

    ngOnInit() {
        this.switchContent(this.route.snapshot.queryParamMap.get('title'));
    }

    gotoEmailPreferences() {
        window.location.href = this.route.snapshot.queryParamMap.get('preferenceLink');
    }

    switchContent(title) {
        if (title == 'subscribe') {
            this.title = 'unsubscribe.resubscribe fail';
            this.content = 'unsubscribe.subscribe fail message';
        } else {
            this.title = 'unsubscribe.unsubscribe fail';
            this.content = 'unsubscribe.unsubscribe fail message';
        }
    }

}
